export const CustomQuestion = {
  getCustomData: () => {
    const date : any = new Date();
    const key = new Date().getTime() + '_' + Math.ceil(Math.random() * 99999);

    return [
      {
        group: 'customFieldDetails',
        type: 'singleChoice',
        name: 'singleChoice',
        title: 'Type Your Question',
        dropIndex: 0,
        elmType: 'custom',
        label: 'Type Your Question',
        leftSideTitle: 'Single Choice',
        options: {
          inline: false,
          defaultValue: '',
          showLabel: false,
          options: [
            {
              value: 'Option 1',
              label: 'Option 1'
            },
            {
              value: 'Option 2',
              label: 'Option 2'
            },
            {
              value: 'Option 3',
              label: 'Option 3'
            }
          ],
          required: false,
          width: '',
          remote: false,
          remoteOptions: [],
          props: {
            value: 'value',
            label: 'label'
          },
          remoteFunc: '',
          disabled: false,
        },
        key: key + '_singleChoice',
        model:
          'singleChoice' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [
          {required: true, message: 'This field is required. (Es necesario llenar este espacio.)'},
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'customFieldDetails',
        type: 'multipleChoice',
        name: 'multipleChoice',
        title: 'Type Your Question',
        dropIndex: 0,
        elmType: 'custom',
        label: 'Type Your Question',
        leftSideTitle: 'Multiple Choice',
        options: {
          inline: false,
          defaultValue: [],
          showLabel: false,
          options: [
            {
              value: 'Option 1'
            },
            {
              value: 'Option 2'
            },
            {
              value: 'Option 3'
            }
          ],
          required: false,
          width: '',
          remote: false,
          remoteOptions: [],
          props: {
            value: 'value',
            label: 'label'
          },
          remoteFunc: '',
          disabled: false,
        },
        key: key + '_multipleChoice',
        model:
          'multipleChoice' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [
          {required: true, message: 'This field is required. (Es necesario llenar este espacio.)'},
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'customFieldDetails',
        type: 'textAreaQuestion',
        name: 'textAreaQuestion',
        title: 'Type Your Question',
        dropIndex: 0,
        elmType: 'custom',
        label: 'Type Your Question',
        leftSideTitle: 'Short Answer',
        options: {
          width: '100%',
          defaultValue: '',
          required: false,
          dataType: 'string',
          pattern: '',
          placeholder: '',
          disabled: false,
        },
        key: key + '_textAreaQuestion',
        model:
          'textAreaQuestion' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [
          {required: true, message: 'This field is required. (Es necesario llenar este espacio.)'},
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'customFieldDetails',
        type: 'textAreaLongQuestion',
        name: 'textAreaLongQuestion',
        title: 'Type your question',
        dropIndex: 0,
        elmType: 'custom',
        label: 'Type your question',
        leftSideTitle: 'Long Answer',
        options: {
          width: '100%',
          defaultValue: '',
          required: false,
          dataType: 'string',
          pattern: '',
          placeholder: 'Type placeholder copy',
          disabled: false,
        },
        key: key + '_textAreaLongQuestion',
        model:
          'textAreaLongQuestion' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [
          {required: true, message: 'This field is required. (Es necesario llenar este espacio.)'},
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'customFieldDetails',
        type: 'dropdown',
        name: 'dropdown',
        title: 'Type your question here',
        dropIndex: 0,
        elmType: 'custom',
        label: 'Type your question here',
        leftSideTitle: 'Dropdown',
        options: {
          inline: false,
          defaultValue: 'Select',
          showLabel: false,
          options: [
            {
              value: 'Option 1'
            },
            {
              value: 'Option 2'
            },
            {
              value: 'Option 3'
            }
          ],
          required: false,
          width: '',
          remote: false,
          remoteOptions: [],
          props: {
            value: 'value',
            label: 'label'
          },
          remoteFunc: '',
          disabled: false,
        },
        key: key + '_dropdown',
        model:
          'dropdown' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [
          {required: true, message: 'This field is required. (Es necesario llenar este espacio.)'},
        ],
        isDrag: true,
        isEditable: false,
        dropdownStatus: false
      }
    ];
  }
};